<template>
    <!-- Banner de incio -->
    <div class="bannerHome">
        <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <h4>Oct 19, 2025</h4>
                <h1>Carrera Atlética XHIDENXHI</h1>
            </div>
            <div class="colImg col-lg-6 col-md-12 col-sm-12 col-xs-12 text-center mt-4">
                <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FJiloMagico.jpg?alt=media&token=2e2974b6-06ff-45e5-aa9f-6a6de2ef777a"
                    alt="Logo Banner" class="imgHome2 img-fluid" />
            </div>
        </div>
    </div>

    <main class="container mt-3 text-center">
        <div class="container">
            <!-- Seccion Principal -->
            <section>
                <div class="row mt-4">
                    <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12">
                        <!-- Card de Información -->
                        <div class="card cardInfo">
                            <img class="logoCard img-fluid" src="@/assets/images/2025/logo2025.jpeg" alt="Logo" />

                            <div class="card-body">
                                <h4 class="textTitle">Carrera entre Senderos</h4>
                                <h5 class="textSubtitle">Canalejas Jilotepec - Estado de México</h5>

                                <ul class="list-group mt-3">
                                    <li class="list-group-item">
                                        <strong class="textBoldBodyCard">Fecha:</strong> <span
                                            class="textRegularBodyCard">Domingo 19 de octubre 2025</span>
                                    </li>
                                    <li class="list-group-item">
                                        <strong class="textBoldBodyCard">Lugar:</strong> <span
                                            class="textRegularBodyCard">Parque el Llano, Canalejas, Jilotepec, Estado de
                                            México</span>
                                    </li>
                                    <li class="list-group-item">
                                        <strong class="textBoldBodyCard">Hora de Inicio:</strong> <span
                                            class="textRegularBodyCard">8:00 AM</span>
                                    </li>
                                    <li class="list-group-item">
                                        <strong class="textBoldBodyCard">Distancias:</strong> <span
                                            class="textRegularBodyCard">10 y 16 Km</span>
                                    </li>
                                </ul>

                                <button class="fillButton">
                                    <a href="https://api.whatsapp.com/send/?phone=525540861907&text&type=phone_number&app_absent=0"
                                        style="color: white; text-decoration: none;">Inscripción finalizada</a>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Bienvenida -->
                    <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12 mt-5 cardBienvenida">
                        <img class="imgBanner img-fluid"
                            src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FLogoPrincipal.png?alt=media&token=7c05bd30-7ab0-475d-83aa-179d4646ac60"
                            alt="Logo" />

                        <h2 class="textBoldBodyCard mt-3">¡Corre, disfruta y vive la naturaleza en el Parque <br> El
                            Llano Canalejas!</h2>
                        <p class="textRegularBodyCard mt-3">
                            "Un recorrido que pondrá a prueba tu cuerpo, mente y espíritu. Rodeado de paisajes que te
                            robarán el aliento y obstáculos que sacarán lo mejor de ti."
                        </p>
                    </div>
                </div>
            </section>

            <!-- Sección de Información -->
            <section id="informacion">
                <h2 class="sectionsTitle">Información de la carrera</h2>

                <div class="row mt-5 justify-content-center">
                    <!-- Información Meta -->
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                        <div class="card sectionObstaculos">
                            <div class="circle">
                                <div class="icon">
                                    <img src="@/assets/images/2025/terminar.png" alt="velocidad">
                                </div>
                            </div>
                            <br>

                            <div class="card-body mt-3">
                                <h5 class="textBoldBodyCard colorPrincipal">Salida y Meta</h5>

                                <h5 class="textBoldBodyCard mt-4">Parque El Llano, Canalejas, <br> Jilotepec, Estado de
                                    México</h5>

                                <h5 class="textRegularBodyCard mt-5">Buscalo en Google Maps como:</h5>
                                <h5 class="textBoldBodyCard mb-2">Bosque de Canalejas</h5>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Sección de Precios y Fases -->
            <section id="registro">
                <h2 class="sectionsTitle">Costos de Inscripción</h2>

                <div class="row row-cols-1 row-cols-md-3 mb-4 mb-lg-0 mt-4">

                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                        <div class="card">
                            <div class="card-header card-fase-header">
                                <h4 class="card-fase-title-style">Fase 1</h4>
                                <h5 class="card-fase-subtitle-style">1 de agosto - 31 de agosto</h5>
                            </div>

                            <div class="card-fase-body mt-4">
                                <h4 class="textTitle mb-0">$300 MXM</h4>
                                <h5 class="textSubtitle mt-0">Por persona</h5>

                                <h4 class="card-fase-subtitle-style2 mt-4">¿Que incluye?</h4>
                                <ul class="list-group list-fase-includes">
                                    <li class="textSubtitle">Playera sublimanda</li>
                                    <li class="textSubtitle">Medalla</li>
                                    <li class="textSubtitle">Pulsera de indentificación</li>
                                    <li class="textSubtitle mb-4">Refrigerio post Carrera</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                        <div class="card">
                            <div class="card-header card-fase-header">
                                <h4 class="card-fase-title-style">Fase 2</h4>
                                <h5 class="card-fase-subtitle-style">1 de septiembre - 20 de septiembre</h5>
                            </div>

                            <div class="card-fase-body mt-4">
                                <h4 class="textTitle mb-0">$350 MXM</h4>
                                <h5 class="textSubtitle mt-0">Por persona</h5>

                                <h4 class="card-fase-subtitle-style2 mt-4">¿Que incluye?</h4>
                                <ul class="list-group list-fase-includes">
                                    <li class="textSubtitle">Playera sublimanda</li>
                                    <li class="textSubtitle">Medalla</li>
                                    <li class="textSubtitle">Pulsera de indentificación</li>
                                    <li class="textSubtitle mb-4">Refrigerio post Carrera</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                        <div class="card">
                            <div class="card-header card-fase-header">
                                <h4 class="card-fase-title-style">Fase 3</h4>
                                <h5 class="card-fase-subtitle-style">1 de octubre - 12 de octubre</h5>
                            </div>

                            <div class="card-fase-body mt-4">
                                <h4 class="textTitle mb-0">$400 MXM</h4>
                                <h5 class="textSubtitle mt-0">Por persona</h5>

                                <h4 class="card-fase-subtitle-style2 mt-4">¿Que incluye?</h4>
                                <ul class="list-group list-fase-includes">
                                    <li class="textSubtitle">Playera sublimanda</li>
                                    <li class="textSubtitle">Medalla</li>
                                    <li class="textSubtitle">Pulsera de indentificación</li>
                                    <li class="textSubtitle mb-4">Refrigerio post Carrera</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0 mt-lg-4">
                        <div class="card">
                            <div class="card-header card-fase-header">
                                <h4 class="card-fase-title-style">Fase 4</h4>
                                <h5 class="card-fase-subtitle-style">13 de octubre - 17 de octubre</h5>
                            </div>

                            <div class="card-fase-body mt-4">
                                <h4 class="textTitle mb-0">$450 MXM</h4>
                                <h5 class="textSubtitle mt-0">Por persona</h5>

                                <h4 class="card-fase-subtitle-style2 mt-4">¿Que incluye?</h4>
                                <ul class="list-group list-fase-includes">
                                    <li class="textSubtitle">Playera sublimanda</li>
                                    <li class="textSubtitle">Medalla</li>
                                    <li class="textSubtitle">Pulsera de indentificación</li>
                                    <li class="textSubtitle mb-4">Refrigerio post Carrera</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0 mt-0 mt-lg-4 ">
                        <div class="card">
                            <div class="card-header card-fase-header">
                                <h4 class="card-fase-title-style">Ultima Fase</h4>
                                <h5 class="card-fase-subtitle-style">Dia del Evento</h5>
                            </div>

                            <div class="card-fase-body mt-4">
                                <h4 class="textTitle mb-0">$500 MXM</h4>
                                <h5 class="textSubtitle mt-0">Por persona</h5>

                                <h4 class="card-fase-subtitle-style2 mt-4">¿Que incluye?</h4>
                                <ul class="list-group list-fase-includes">
                                    <li class="textSubtitle">Playera sublimanda</li>
                                    <li class="textSubtitle">Medalla</li>
                                    <li class="textSubtitle">Pulsera de indentificación</li>
                                    <li class="textSubtitle mb-4">Refrigerio post Carrera</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <!-- Sección de ¿Como inscribirse? -->
            <section>
                <h2 class="sectionsTitle"> ¿Como Inscribirte?</h2>

                <div class="card p-4 sectionObstaculos mt-4">

                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0 mb-md-0">
                            <!-- Lado izquierdo -->
                            <div class="card sectionObstaculos mt-4">
                                <div class="circle">
                                    <div class="icon">
                                        <img src="@/assets/images/2025/uno.png" alt="velocidad">
                                    </div>
                                </div>

                                <div class="card-body mt-4">
                                    <div class="text-center">
                                        <h5 class="card-fase-subtitle-style2" style="color: #567067;">Realiza tu pago:
                                        </h5>
                                        <p class="textSubtitle">Elige tu forma favorita</p>

                                        <h6 class="card-fase-subtitle-style2 mt-4">Efectivo en Gimnasio El Terreno</h6>
                                        <p class="textSubtitle">Horario de Atención: lunes a viernes - 5pm - 8pm</p>

                                        <h6 class="card-fase-subtitle-style2 mt-4">Transferencia bancaria</h6>
                                        <p class="textSubtitle">7289 6900 0028 945078</p>

                                        <h6 class="card-fase-subtitle-style2 mt-4">Depósito OXXO</h6>
                                        <p class="textSubtitle">2242 1704 2012 2648</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-0 mb-lg-0">
                            <div class="card sectionObstaculos mt-4">
                                <div class="circle">
                                    <div class="icon">
                                        <img src="@/assets/images/2025/dos.png" alt="velocidad">
                                    </div>
                                </div>

                                <div class="card-body mt-4">
                                    <div class="text-center">
                                        <h5 class="card-fase-subtitle-style2" style="color: #567067;">Envia tu
                                            comprobante:</h5>
                                        <p class="textSubtitle">Al número: 5540861907</p>

                                        <h6 class="card-fase-subtitle-style2 mt-4">Con los siguientes datos:</h6>
                                        <p class="textSubtitle mb-2">Nombre Completo</p>
                                        <p class="textSubtitle mb-2">Talla de playera</p>
                                        <p class="textSubtitle mb-2">Distancia elegida (10 o 16KM)</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Sección de Beneficios -->
            <section>
                <h2 class="sectionsTitle">Beneficios</h2>

                <p class="textSubtitle mb-1">Al adquirir tu kit de participación, no solo te unes a una increíble
                    carrera</p>
                <p class="textSubtitle">¡También obtienes acceso total al parque durante todo el día!</p>
            </section>

            <!-- Sección de Patrocinadores -->
            <section class="sponsors">
                <div class="container text-center">
                    <h2 class="sectionsTitle">Nuestros Patrocinadores</h2>
                    <p class="mb-1 textSubtitle">Gracias a su apoyo, esta carrera es posible.</p>

                    <div class="row g-4 justify-content-center mt-3">
                        <!-- Sponsor 1 -->
                        <div class="col-6 col-md-3">
                            <div class="sponsor-card p-3 shadow-sm rounded">
                                <img src="@/assets/images/patrocinadores/pat_2.jpeg" alt="Patrocinador 1" class="img-fluid">
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    </main>
</template>

<script setup>
import '@fortawesome/fontawesome-free/css/all.css'
import { onMounted, onUnmounted } from 'vue'

onMounted(() => {
  document.body.style.backgroundColor = '#F6F6F6'
})

onUnmounted(() => {
  document.body.style.backgroundColor = '#F6F1EC'
})
</script>

<style scoped>
#navModified {
    background: #1E7BC1;
}

#navModified .nav-link {
    font-family: 'FuentePersonalizada', Arial sans-serif;
    font-size: 25px;
}

.sponsors h2 {
    font-size: 2rem;
    color: #333;
}

.sponsor-card {
    background: #fff;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.sponsor-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
}

.sponsor-card img {
    max-height: 100px;
    object-fit: contain;
}

body {
    background-color: #F6F6F6;
    margin: 0;
}

#navModified {
    background: #567067;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

#navModified .nav-link {
    font-family: 'GYMZain', Arial sans-serif;
    font-weight: bold;
    color: white;
    font-size: 22px;
}

.logo {
    display: flex;
    align-items: center;
}

.logo img {
    height: 80px;
    margin-right: 10px;
}

.logo span {
    font-size: 20px;
    font-weight: bold;
    color: white;
    margin-right: 10px;
}

#info ul {
    list-style: none;
    display: flex;
    padding: 0;
    margin: 0;
}

#info ul li {
    margin: 0 15px;
}

#info ul li a {
    color: white;
    text-decoration: none;
    font-size: 16px;
}

/* Estilo para el banner */
.bannerHome {
    background-color: #303030;
    padding: 16px;
}

.bannerHome h4 {
    font-family: 'GYMZain', Arial sans-serif;
    font-weight: normal;
    color: #fff;
    font-size: 2rem;
    margin: 0 0 0 0;
}

.bannerHome h1 {
    font-family: 'GYMZain', Arial sans-serif;
    font-weight: bold;
    font-size: 5rem;
    color: #fff;
}

.bannerHome img {
    margin: 0 auto;
    width: 190px;
    height: 190px;
}

.bannerHome .imgHome1,
.bannerHome .imgHome2 {
    border-radius: 120px;
}

/* Colores de texto */
.colorPrincipal {
    color: #567067;
}

/* Textos de las secciones*/
.sectionsTitle {
    margin-top: 60px;
    font-family: "GYMZain", sans-serif;
    font-size: 33px;
    font-weight: bold;
}

/* Estilo para el card Principal */
.cardInfo {
    border-color: #DDDDDD;
    padding-top: 15px;
    padding-bottom: 15px;
}

.textTitle {
    font-family: "GYMZain", sans-serif;
    font-size: 28px;
    font-weight: bold;
    line-height: 1;
    margin: 0;
}

.textSubtitle {
    font-family: "GYMZain", sans-serif;
    font-size: 20px;
    font-weight: lighter;
    line-height: 1;
    margin: 0;
}

.textRegularBodyCard {
    font-family: "GYMZain", sans-serif;
    font-size: 20px;
    font-weight: lighter;
    margin: 0;
}

.textBoldBodyCard {
    font-family: "GYMZain", sans-serif;
    font-size: 20px;
    font-weight: bold;
    margin: 0;
}

.fillButton {
    background-color: #567067;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 8px 20%;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    text-decoration: none;
    margin-top: 20px;
}

.logoCard {
    margin-top: 15px;
    border-radius: 120px;
    height: 180px;
    width: 180px;
    margin: 0 auto;
    object-fit: cover;
}

.imgBanner {
    margin: 0 auto;
    height: 180px;
    width: 180px;
}

.cardBienvenida {
    padding: 16px;
}

.sectionObstaculos {
    position: relative;
    overflow: visible;
}

.sectionObstaculos .circle {
    width: 70px;
    height: 70px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -35px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
}

.sectionObstaculos .circle .icon img {
    width: 35px;
    height: auto;
}

.list-group li {
    padding: 5px;
}

/* Estilo para el card de precios */
#registro ul {
    list-style: none;
    display: flex;
    padding: 0;
    margin: 0;
}

#registro ul li {
    margin: 0 15px;
}

#registro ul li a {
    color: white;
    text-decoration: none;
    font-size: 16px;
}

.card-fase-header {
    background-color: #567067;
    padding: 10px;
}

.card-fase-title-style {
    font-family: "GYMZain", sans-serif;
    font-size: 26px;
    font-weight: bold;
    color: white;
    margin: 0;
}

.card-fase-subtitle-style {
    font-family: "GYMZain", sans-serif;
    font-size: 20px;
    font-weight: normal;
    color: white;
    margin: 0;
}

.card-fase-subtitle-style2 {
    font-family: "GYMZain", sans-serif;
    font-size: 22px;
    font-weight: bold;
    margin: 0;
}

.full-center {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
}

.gradient-bg {
    background: linear-gradient(to right, #2e473a, #6b8f89);
    color: white;
    border-radius: 1rem;
    overflow: hidden;
    max-width: 800px;
}

.icon-circle {
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
}

.feature-text {
    font-size: 0.95rem;
}
</style>
